import React from 'react';
import './Car.css';

const Car = () => {

  return (
    <section id="car" className="section car">
      <div className="container">
        <h2 className="section-title progressive-element">הרכב שלי</h2>
        
        <div className="car-content">
          <div className="image-container progressive-element">
            <img 
              src="/images/car_ran.jpg" 
              alt="רן לוי - רכב לימוד נהיגה" 
              className="section-image"
            />
            <div className="image-overlay"></div>
          </div>
          
          <div className="car-info dynamic-content">
            <div className="car-highlight-text">
              <h4 className="car-highlight-title progressive-element stagger-1">
                טיוטה קורולה היברידית 🌱
              </h4>
              <p className="car-highlight-subtitle progressive-element stagger-2">
                חזקה ונוחה ללימוד נהיגה
              </p>
              <p className="car-highlight-description progressive-element stagger-3">
                בעלת מצלמה אחורית רחבה ושדה ראייה נוח מלפנים ולאחור ותעזור לכם להשלים את חווית לימוד הנהיגה
              </p>
              <p className="car-highlight-experience progressive-element stagger-4">
                רכב היברידי מתקדם המשלב בין יעילות אנרגטית לנוחות מרבית
              </p>
              <div className="car-benefits progressive-element stagger-5">
                <p>🎯 מצלמה אחורית רחבה לשדה ראייה מושלם</p>
                <p>🌿 טכנולוגיה היברידית חסכונית וידידותית לסביבה</p>
                <p>🛡️ מערכות בטיחות מתקדמות של טיוטה</p>
                <p>🚗 נוחות מרבית ללימוד נהיגה בטוח</p>
                <p>👁️ שדה ראייה נוח מלפנים ולאחור</p>
                <p>⚡ ביצועים חלקים ושליטה קלה</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Car;
